/**
 * ValueStrings - Centralized string constants for date formats and URLs.
 * XlsNormalizefileKey - Keys for Excel normalization.
 * TagColorOptions - Color palette for tags.
 *
 * Extendable for future localization and configuration needs.
 */
export const ValueStrings = {
  DATE_FORMAT_SMALL: "dd/MM/yyyy",
  DATE_TIME_SECONDS_FORMAT: "dd/MM/yyyy HH:mm:ss",
  DATE_TIME_SECONDS_FORMAT_PLACEHOLDER: "DD/MM/YYYY HH:MM:SS",
  dateFormat: "DD/MM/YYYY",
  dateFormatMonth: "MM/DD/YYYY",
  installationDateFormat: "YYYY-MM-DD",
  contactUsPageLink: "https://www.dupont.com/water/contact-us.html",
};
export const XlsNormalizefileKey = {
  date: "date",
  feedFlowrate: "feed_flowrate",
  filtrateFlowrate: "filtrate_flowrate",
  // concentrateFlowrate: "concentrate_flowrate",
  // permeateFlow: "permeate_flowrate",
  feedPressure: "feed_pressure",
  filtratePressure: "filtrate_pressure",
  // concentratePressure: "concentrate_pressure",
  // permeatePressure: "permeate_pressure",
  // pressureDrop: "pressure_drop",
  // feedQuality: "feed_quality",
  // permeateConductivity: "permeate_quality",
  feedTemp: "feed_temp",
  tmpDrop: "tmp_drop",
  feedSuspended: "feed_suspended",
  filtrateSuspened: "filtrate_suspended",
  // failureProbability: "Failure Probability",
  normalizeTmp: "norm_tmp",
  normalizeFiltrateFlow: "norm_filtrate_flow",
  // normalizeDPRack2: "norm_pressure_drop",
  // calculateFeedTDS: "calculated_feed_TDS",
  // permeateTDS: "permeate_TDS"
};

export const TagColorOptions = [
  {
    name: "Teal",
    code: "#128370",
  },
  {
    name: "Pink",
    code: "#FC2D72",
  },
  {
    name: "Orange",
    code: "#FF9E19",
  },
  {
    name: "Green",
    code: "#58B947",
  },
  {
    name: "Blue",
    code: "#00A9E0",
  },
  {
    name: "Purple",
    code: "#5F259F",
  },
  {
    name: "Light Pink",
    code: "#FFA3CA",
  },
  {
    name: "Dark Blue",
    code: "#004c97",
  },
  {
    name: "Light Orange",
    code: "#FFCD00",
  },
  {
    name: "Light Green",
    code: "#A4D65E",
  },
  {
    name: "Light Teal",
    code: "#6DD8CD",
  },
  {
    name: "Light Blue",
    code: "#8BDCF9",
  },
  {
    name: "Light Purple",
    code: "#AD87F7",
  },
  {
    name: "Vivid Purple",
    code: "#C900E3",
  },
  {
    name: "Brown",
    code: "#844700",
  },
];

export const HistoricCECTypeString = {
  "shutdown": "addCIPStrings.shutDown",
  "cip": "addCIPStrings.cip",
  "ceb": "addCIPStrings.ceb",
  "shutdown with cec": "addCIPStrings.shutdownWithCEC",
}

export const SFDC_ENGAGEMENT_CONSTANTS = {
  webVisitorID: "0000-000-0000",
  engagementName: "UF Operations Advisor",
  engagementStatus: "close",
  engagementSource: "Website",
  owningOrganization: "WS",
  formId: 1001,
  buQuestion1: "",
  buAnswer1: "",
};

export const SFDC_ENGAGEMENT_API_URL = process.env.REACT_APP_SFDC_ENGAGEMENT_API_URL;
